import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../hooks/useAuthStore";
import { getTabScope, getTabToken } from "../stores/auth.store";

// This tab's session decides where it belongs. Other tabs may be signed in as
// other roles, so their stored tokens must not steer this tab's routing.
const dashboardPathForScope = (scope) => {
  if (scope === "admin") return "/admin";
  if (scope === "assistant") return "/dashboards/assistant/overview";
  return "/user/travel-assistant";
};

export default function RoleRoute({ allow }) {
  const location = useLocation();
  const { isAuthenticated, isLoading, token } = useAuthStore();

  if (isLoading && token) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#61013B]" />
      </div>
    );
  }

  // No session in this tab: never signed in, or ended from another tab of the
  // same role. Sending it to a dashboard instead would bounce straight back.
  if (!isAuthenticated || !getTabToken()) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  // Route on the tab's session alone. The hydrated role can lag a refresh
  // behind, and routing on both could bounce between two dashboards.
  const tabScope = getTabScope();
  if (tabScope !== allow) {
    return (
      <Navigate
        to={dashboardPathForScope(tabScope)}
        replace
        state={{ from: location }}
      />
    );
  }

  return <Outlet />;
}
